<template>
    <tab-bar>
        <tab-bar-item link="/MallHome">
            <img slot="icon" src="../../../assets/img/tabbar/home.svg">
            <img slot="active-icon" src="../../../assets/img/tabbar/home_active.svg">
            <div slot="text">首页</div>
        </tab-bar-item>
        <tab-bar-item link="/MallCategory">
            <img slot="icon" src="../../../assets/img/tabbar/category.svg">
            <img slot="active-icon" src="../../../assets/img/tabbar/category_active.svg">
            <div slot="text">分类</div>
        </tab-bar-item>
        <tab-bar-item link="/MallCart">
            <img slot="icon" src="../../../assets/img/tabbar/cart.svg">
            <img slot="active-icon" src="../../../assets/img/tabbar/cart_active.svg">
            <div slot="text">购物车</div>
        </tab-bar-item>
        <tab-bar-item link="/MallProfile">
            <img slot="icon" src="../../../assets/img/tabbar/profile.svg">
            <img slot="active-icon" src="../../../assets/img/tabbar/profile_active.svg">
            <div slot="text">我的</div>
        </tab-bar-item>
    </tab-bar>
</template>

<script>
    import TabBarItem from "../../common/tabbar/TabBarItem";
    import TabBar from "../../common/tabbar/TabBar";
    export default {
        name: "MainTabBar",
        components: {TabBar, TabBarItem}
    }
</script>

<style scoped>

</style>